import React, { useMemo } from "react";
import Chart from "components/charts/Chart";

/**
 * Pie of category shares. `slices` is `[{label, value}]`; values are raw counts
 * and are shown as rounded percentages. All-zero data renders the empty state.
 */
const DistributionPie = ({ slices, colors, emptyText }) => {
  const { series, options } = useMemo(() => {
    const total = slices.reduce((sum, slice) => sum + (slice.value || 0), 0);
    return {
      series: slices.map((slice) =>
        total > 0 ? Math.round(((slice.value || 0) / total) * 100) : 0
      ),
      options: {
        labels: slices.map((slice) => slice.label),
        colors,
        legend: { position: "bottom", horizontalAlign: "center" },
        dataLabels: { enabled: true, formatter: (val) => `${Math.round(val)}%` },
        tooltip: { y: { formatter: (val) => `${val}%` } },
      },
    };
  }, [slices, colors]);

  return <Chart type="pie" series={series} options={options} height={250} emptyText={emptyText} />;
};

export default DistributionPie;
